<template>
  <dialog-add
    icon="calendar_month"
    :title="title"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-creator-program-invoice class="elevation-1" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/creator-program/invoices');
    },
  },
  computed: {
    activeInvoice() {
      return this.$store.getters['creatorProgram/activeInvoice'];
    },
    title() {
      if (this.activeInvoice?.id) {
        return this.activeInvoice.id.toString();
      }
      return 'Invoice';
    },
  },
};
</script>
